const mockShifts = [{
  shiftDuration: '12',
  shiftName: 'Day',
  isAlternating: true,
  shiftAltDuration: '12',
  shiftAltName: 'Night',
}, {
  shiftDuration: '12',
  shiftName: 'Night',
}, {
  shiftDuration: '8',
  shiftName: 'Day',
}];
export default mockShifts;
